var React = require('react');

function BlueStack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.46154 0C1.9975 0 0 1.53592 0 3.43058V23.9051C0 25.4515 0.89134 26.8594 2.28913 27.5208L13.3309 32.7456C14.0478 33.0848 14.9522 33.0848 15.6691 32.7456L26.7109 27.5208C28.1087 26.8594 29 25.4515 29 23.9051V3.43058C29 1.53592 27.0025 0 24.5385 0H4.46154Z","fill":"#30A8FF"}));
}

BlueStack.defaultProps = {"width":"29","height":"33","viewBox":"0 0 29 33","fill":"none"};

module.exports = BlueStack;

BlueStack.default = BlueStack;
